'use client'

import useFetch from '@hook/useFetch'
import useLogin from '@hook/useLogin'
import { includes } from 'lodash-es'
import { createContext, useCallback, useContext } from 'react'
import { useUnmount } from 'react-use'

const SubscribeLiveContext = createContext()

export function SubscribeLiveContextProvider({
  children
}) {
  const { isLogin } = useLogin()
  const { data, mutate } = useFetch(isLogin ? 'meetup/events/user/subs' : null)
  const isSubscribed = useCallback((id) => Boolean(includes(data, id)), [data])

  useUnmount(() => {
    mutate(undefined, true)
  })

  return (
    <SubscribeLiveContext.Provider value={isSubscribed}>
      {children}
    </SubscribeLiveContext.Provider>
  )
}

export function useSubscribeLiveContext() {
  return useContext(SubscribeLiveContext)
}
